import * as zod from 'zod'

export const addWorkerCredentialFlowSchema = zod.object({
  workerRequirementId: zod.number({
    invalid_type_error: 'Credential is required',
    required_error: 'Credential is required',
  }),
})

export type AddWorkerCredentialFlowSchema = zod.infer<
  typeof addWorkerCredentialFlowSchema
>
